<template>
  <div>

    <router-view/>
        <div style="height:70px"></div>
         <van-tabbar v-model="active">
          <van-tabbar-item name="/" to="/" icon="wap-home-o">Home</van-tabbar-item>
          <van-tabbar-item name="Ürünler" to="/yeni-bayi" icon="send-gift-o">Yeni Bayi</van-tabbar-item>
          <van-tabbar-item name="Ödeme" to="/urunler" icon="point-gift-o">Ürünler</van-tabbar-item>
          <van-tabbar-item name="Extre" to="/agac" icon="cluster-o">Ağaç</van-tabbar-item>
          <van-tabbar-item name="Cüzdan" to="/cuzdan" icon="paid">Cüzdan</van-tabbar-item>
          <van-tabbar-item v-if="kod !==1234567890" name="Hesabım" to="/hesap" icon="friends-o">Hesap</van-tabbar-item>
          <van-tabbar-item v-if="kod ===1234567890"  name="Admin" to="/havuz" icon="friends-o">Admin</van-tabbar-item>
         </van-tabbar>
  </div>
</template>

<script>
import {helper} from '@/helper'; //export default olmadığı için süslü paranteze alabildik
import { userService } from '@/plugins/_services';
export default {
  name: 'app',
    data() {
      return {
          active:'',
          kod:helper.settings.ayar().uye,
      };
  },
  computed: {
  },  
  created(){
    //this.active = this.$route.name
    //alert("drg")
  },
  methods: { 

    cikis(){userService.logout();},
    sepetadet(){
    //  this.box = JSON.parse(localStorage.getItem('osmBox')).baskets.length || 0
    }
  }  
}
</script>



// WEBPACK FOOTER //
// src/components/content.vue